// extracted by mini-css-extract-plugin
module.exports = {"results":"styles_results__3BhBj"};